<template>
    <div class="content">
        <Panel
            v-for="[subject, bindings] of Object.entries(explanations)"
            :header="subject"
        >
            <DataTable :value="bindings">
                <ColumnGroup type="header">
                    <!-- Remove table header -->
                </ColumnGroup>
                <Column field="keys" style="width: 15rem">
                    <template #body="{ data }">
                        <template v-for="combination in data.keys.split(' ')">
                            <template v-for="key in combination.split('+')">
                                <Tag severity="secondary">{{ key }}</Tag>
                                <span
                                    v-if="
                                        !isLastInArray(
                                            key,
                                            combination.split('+')
                                        )
                                    "
                                >
                                    +
                                </span>
                            </template>
                            <span
                                v-if="
                                    !isLastInArray(
                                        combination,
                                        data.keys.split(' ')
                                    )
                                "
                            >
                                , then
                            </span>
                        </template>
                    </template>
                </Column>
                <Column field="explanation"></Column>
            </DataTable>
            <Divider
                v-if="!isLastInObject(subject, explanations)"
                layout="vertical"
            />
        </Panel>
    </div>
</template>

<script lang="ts" setup>
import { Ref, onMounted, inject, ref } from "vue";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import type { StringKeyBindingExplanation } from "@/composables/keybindings-explanation";
import Tag from "primevue/tag";

type Data = Record<string, StringKeyBindingExplanation[]>;

const dialogRef = inject<Ref<DynamicDialogInstance>>("dialogRef");
const explanations = ref<Data>({});

onMounted(() => {
    if (!dialogRef?.value.data) {
        return;
    }
    // Only add subjects which actually have bindings.
    explanations.value = Object.fromEntries(
        Object.entries(dialogRef.value.data as Data).filter(
            ([_, bindings]) => bindings.length
        )
    );
});

const isLastInArray = (key: string, array: [string]): boolean => {
    return key === array[array.length - 1];
};
const isLastInObject = (
    key: string,
    object: Record<string, unknown>
): boolean => {
    return key === Object.keys(object)[Object.keys(object).length - 1];
};
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    grid-gap: 1em;

    > div {
        flex: 500px 1 0;
    }
}
</style>
